import React from 'react';
import './About.css';
import { FaTools, FaIndustry, FaRobot, FaCogs } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>P R O J E C T  
          <br></br><div style={{position: 'relative', textAlign: 'center'}}>P O W E R <span style={{fontSize: '1rem', display: 'inline'}}>BY CW</span></div></h1>
        
        <div className="about-section">
          <p className="about-intro">
            Our speciality at Project Power By CW is offering specialised engineering solutions that are suited to the particular requirements of the industrial and manufacturing sectors. In order to maximise production efficiency, accuracy, and workflow automation, we, as system integrators, design and construct custom acrylic and metal jigs, precision fixtures, and specialised equipment.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Expertise</h2>
          <p>
            Our experience extends to a variety of sectors where accuracy and dependability are essential, such as industrial automation, electronics, automotive, and aerospace. We collaborate closely with customers to fully grasp their needs before creating custom solutions that boost output, strengthen quality assurance, and expedite assembly procedures.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <FaTools className="service-icon" />
              <h3>Custom Acrylic & Metal Jigs</h3>
              <p>Designed for durability, precision, and ease of use</p>
            </div>
            <div className="service-item">
              <FaIndustry className="service-icon" />
              <h3>Precision Tooling & Fixtures</h3>
              <p>Tailored solutions for machining, assembly, and testing</p>
            </div>
            <div className="service-item">
              <FaRobot className="service-icon" />
              <h3>Automation & System Integration</h3>
              <p>Optimizing workflows through advanced engineering</p>
            </div>
            <div className="service-item">
              <FaCogs className="service-icon" />
              <h3>Prototype Development</h3>
              <p>Rapid fabrication for testing and validation</p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <p className="about-commitment">
            With a commitment to innovation, quality, and efficiency, we ensure that every solution we deliver meets industry standards and exceeds client expectations. Let us help you optimize your production with customized engineering solutions that drive performance and precision.
          </p>
        </div>

        <div className="about-section cta-section">
          <h2>Contact us today to discuss your requirements</h2>
          <a href="https://wa.me/60162865881" className="cta-button-about">Get in Touch</a>
        </div>
      </div>
    </div>
  );
};

export default About; 